/**
 * Save Warning Dialog & Puzzle Save
 *
 * Show/hide the "unsaved changes" warning popup and save puzzle to server.
 */

import { appState } from '../state/AppState';
import { session } from './puzzleSession';
import { hideOverlayDivs } from './domSetup';
import { updateMainMenu } from './menuUpdates';

/**
 * Show save warning dialog.
 * Like legacy showMentes: shows popup with save/cancel options.
 */
export function showSaveWarning(): void {
    if (appState.isSaved) return;

    const popup = document.getElementById('rejtveny_popupmenu');
    const puzzleEl = document.getElementById('rejtveny');
    const zarFixMenu = document.getElementById('zarFixMenu');
    const zarRejtveny = document.getElementById('zarRejtveny');
    const zarPopUp = document.getElementById('zarPopUp');
    const component = document.getElementById('rejtvenyKomponens');

    if (!popup || !puzzleEl) return;

    // Build popup content (like legacy showMentes)
    const html = `<form>
        <div class="input-block">A nem mentett változtatások el fognak veszni!</div>
        <div class="input-block">
            <input type="button" id="saveWarningOkBtn" value="Mentés">
            <input type="reset" id="saveWarningCancelBtn" value="Mégse">
        </div>
    </form>`;

    popup.innerHTML = html;

    // Position popup (like legacy updatePopup)
    popup.style.display = 'block';
    popup.style.left = `${Math.ceil(
        puzzleEl.offsetWidth / 2 - popup.offsetWidth / 2,
    )}px`;
    popup.style.top = `${Math.ceil(
        puzzleEl.offsetHeight / 2 - popup.offsetHeight / 2,
    )}px`;

    // Hide/show overlay elements (like legacy showPopup)
    if (zarFixMenu) zarFixMenu.style.display = 'none';
    if (zarRejtveny) zarRejtveny.style.display = 'none';
    if (zarPopUp) zarPopUp.style.display = 'block';
    if (component) component.style.position = 'static';

    // Attach event handlers
    const saveBtn = document.getElementById('saveWarningOkBtn');
    const cancelBtn = document.getElementById('saveWarningCancelBtn');

    if (saveBtn) {
        saveBtn.addEventListener('click', () => {
            // Save the puzzle (like legacy mentes)
            savePuzzle();
            hideSaveWarning();
        });
    }

    if (cancelBtn) {
        cancelBtn.addEventListener('click', () => {
            // Cancel - hide popup and overlays (like legacy mentesMegse)
            hideSaveWarning();
        });
    }
}

/**
 * Hide save warning dialog.
 * Like legacy mentesMegse: hides popup and overlay divs.
 */
export function hideSaveWarning(): void {
    const popup = document.getElementById('rejtveny_popupmenu');
    const zarFixMenu = document.getElementById('zarFixMenu');
    const zarRejtveny = document.getElementById('zarRejtveny');
    const zarPopUp = document.getElementById('zarPopUp');
    const component = document.getElementById('rejtvenyKomponens');

    if (popup) popup.style.display = 'none';
    if (zarFixMenu) zarFixMenu.style.display = 'none';
    if (zarRejtveny) zarRejtveny.style.display = 'none';
    if (zarPopUp) zarPopUp.style.display = 'none';
    if (component) component.style.position = 'relative';

    // Focus back on current element
    appState.currentElement?.focus();
}

/**
 * Save the puzzle to the server
 */
export function savePuzzle(): void {
    if (!session.currentPuzzle) return;

    const xmlData = session.currentPuzzle.toXml();
    const idParam = appState.isBuilderMode
        ? `rejtvenyID=${appState.puzzleId}`
        : `fejtesID=${appState.solutionId}`;

    fetch(`/mentes?${idParam}&ellenorizve=${appState.isVerified ? '1' : '0'}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'text/xml;charset=UTF-8',
        },
        body: xmlData,
    })
        .then((response) => {
            if (response.ok) {
                appState.isSaved = true;
                hideOverlayDivs();
                updateMainMenu();
                console.log('Puzzle saved successfully');
            } else {
                console.error('Save failed');
            }
        })
        .catch((error) => {
            console.error('Save error:', error);
        });
}
